export const TIP_DURATION = 4000;

export const TOSS_TIPS = [
  '운영진이 실시간으로 송금 내역을 확인하고 있습니다',
  '토스 앱이 열리지 않았다면 재시도 버튼을 눌러보세요',
  '확인 완료 시 자동으로 주문 내역 페이지로 이동합니다',
  '이 화면을 닫지 말고 잠시만 기다려주세요',
] as const;

export const BANK_TRANSFER_TIPS = [
  '운영진이 실시간으로 송금 내역을 확인하고 있습니다',
  '은행 앱에서 위 계좌로 송금을 완료해주세요',
  '확인 완료 시 자동으로 주문 내역 페이지로 이동합니다',
  '이 화면을 닫지 말고 잠시만 기다려주세요',
] as const;

export const TOSS_STEPS = [
  '토스 앱에서 송금을 완료해주세요',
  '앱이 열리지 않으면 아래 버튼으로 재시도해주세요',
  '확인되면 자동으로 주문 내역 페이지로 이동합니다',
] as const;

export const BANK_TRANSFER_STEPS = [
  '위 계좌번호를 복사하고 은행 앱에서 송금해주세요',
  '송금 후 이 화면에서 잠시만 기다려주세요',
  '확인되면 자동으로 주문 내역 페이지로 이동합니다',
] as const;
